import react, { PureComponent } from 'react';

class FormikInput extends PureComponent {

    handleChange = (event) => {
        const { name, onChange } = this.props;
        onChange(name, event.target.value);

    }

    render() {
        const { name, id, value, disabled, type, className, required, placeholder } = this.props;
        
        const classes = `ui input ${className}`;
        return (
            <div className={classes}>
                <input
                    onChange={this.handleChange}
                    disabled={disabled}
                    name={name}
                    value={value}
                    type={type}
                    id={id}
                    required={required}
                    placeholder={placeholder} />      
                {this.props.children}
            </div>
        );
    }

}

export default FormikInput;